import OnaModal from './OnaModal'

export default OnaModal